import React, {FC} from 'react';
import styled from 'styled-components';

import {getMappedValue} from '../../../../../utils/FNUtils';

const MAX_BAR_HEIGHT = 14;

const GraphWrapper = styled.div`
    display: flex;
    align-items: flex-end;
`;

const Bar = styled.div<{
    trend: number;
    height: number;
}>`
    width: 3px;
    height: ${p => p.height}px;
    margin-right: 2px;
    background-color: ${p =>
        getMappedValue<string>(p.trend, {
            positive: p.theme.muiTheme.palette.success.light,
            zero: p.theme.muiTheme.palette.success.light,
            negative: p.theme.muiTheme.palette.error.light
        })};
`;

export interface TrendProps {
    stats: number[];
    trend: number;
}

const SparkLineGraph: FC<TrendProps> = ({stats, trend}: TrendProps) => {
    const maxStat = Math.max(...stats);
    const bars = stats.map(stat => Math.round((stat / maxStat) * MAX_BAR_HEIGHT));

    return (
        <GraphWrapper>
            {bars.map((bar, index) => (
                <Bar key={index} trend={trend} height={bar} />
            ))}
        </GraphWrapper>
    );
};

export default SparkLineGraph;
